import React, { useState } from 'react';
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Alert from '../Alert';
import ForgottenPasswordForm from './ForgottenPasswordForm';
import { useAuth } from '../../context/AuthContext';
import { withAuth } from 'ecrion-components';
import DocumentTitle from 'react-document-title';
import {Formatter } from "ecrion-components";

//This theme is used to wrap the outlined textfields, as the ecrion components' theme
//breaks some of their properties and needs to be revised
const LoginFormTheme = (outerTheme) =>
  createMuiTheme({
    ...outerTheme,
    overrides: {
      ...outerTheme.overrides,
      MuiOutlinedInput: {
        ...outerTheme.overrides.MuiOutlinedInput,
        input: null,
      },
    },
    props: {
      ...outerTheme.props,
      MuiInputLabel: null,
    },
  });

const useStyles = makeStyles({
  boxContainer: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  container: {
    width: 300,
    margin: 'auto',
  },
  alertInfo: {
    textAlign: 'center',
    width: '100%',
  },
  button: {
    textTransform: 'none',
    minWidth: 80,
    borderRadius: "6px"
  },
});

const LoginForm = ({ match, location, history, setAuth }) => {
  const [environment, setEnvironment] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [requestFailed, setRequestFailed] = useState('');
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [urlEnvironment, setUrlEnvironment] = useState(false);

  const { login } = useAuth();

  const receivedEnvironment = decodeURIComponent(
    match.params.environment || ''
  );

  React.useEffect(() => {
    if (receivedEnvironment) {
      setEnvironment(receivedEnvironment);
      setUrlEnvironment(true);
    }

    const urlParams = new URLSearchParams(location.search);
    const receivedUserName = urlParams.get('userName');
    if (receivedUserName) setUsername(receivedUserName);
  }, []);

  const classes = useStyles();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await login({ environment, username, password });
      setAuth({ token: localStorage.getItem('ECR.EOS.AccessToken') });
      const encodedEnvironment = encodeURIComponent(environment);

      if (
        location.pathname.split('/')[1] !== environment.replace(/&/g, '%26')
      ) {
        history.push(`/${encodedEnvironment}/forms`);
      }
    } catch (error) {
      setRequestFailed(error.message);
    }
  };

  return (
    <DocumentTitle title="Sign in - Customer Portal">
      <Box>
      <MuiThemeProvider theme={LoginFormTheme}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={2} direction="column">         
           
                {!urlEnvironment && (
                  <Grid item>
                    <TextField
                      required
                      id="environment"
                      label="Environment"
                      variant="outlined"
                      fullWidth
                      size="small"
                      onChange={(e) => setEnvironment(e.target.value)}
                      style={{backgroundColor: 'white'}}
                    />
                  </Grid>
                )}
                <Grid item>
                  <TextField
                    required
                    id="username"
                    label="Username"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    style={{backgroundColor: 'white'}}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    required
                    id="password"
                    label="Password"
                    type="password"
                    autoComplete="current-password"
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) => setPassword(e.target.value)}
                    style={{backgroundColor: 'white'}}
                  />
                </Grid>

                <Grid item align="right">
                  <Formatter.Link
                      text="Forgot password?"
                      onClick={() => setPasswordDialog(true)}
                      title="Forgot password?"
                    />
                </Grid>

                <Grid item style={{ marginTop: 16 }}>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                  >
                    <Grid item>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.button}
                      >
                        Sign In
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>

                {requestFailed && (
                  <Grid item>
                    <Alert align="center">{requestFailed}</Alert>
                  </Grid>
                )}
                
            
            </Grid>
          </form>
        
        {passwordDialog && (
          <ForgottenPasswordForm
            onClose={() => setPasswordDialog(false)}
            environment={receivedEnvironment}
          />
        )}
        </MuiThemeProvider>
      </Box>
    </DocumentTitle>
  );
};

export default withAuth(LoginForm);
